module.exports = __webpack_public_path__ + "static/img/serverShop1.77729f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/serverShop1.png
// module id = 8P6K
// module chunks = 0